import HeaderComp from 'Components/common/Header/Header'
import styles from './Home.module.less'
import { useEffect, useMemo, useState } from 'react'
import { PAGE_TITLES } from 'Constants/page.constants'
import Tabs from 'antd/lib/tabs'
import { ExamsTab } from './tabs/ExamsTab'
import { useTitle } from 'Hooks/use-title'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { HomeTabKeys } from 'Constants/constants'
import { TasksTab } from 'Pages/Home/tabs/TasksTab.tsx'
import { TimesheetTab } from './tabs/TimesheetTab'

export const Home = () => {
    useTitle(PAGE_TITLES.HOME)
    const navigate = useNavigate()
    const location = useLocation()
    const [selectedTab, setSelectedTab] = useState<HomeTabKeys>()
    const [searchParams] = useSearchParams()

    const tabItems = useMemo(
        () => [
            {
                key: HomeTabKeys.Tasks,
                label: 'Tasks Queues',
                children: <TasksTab />,
            },
            {
                key: HomeTabKeys.Exams,
                label: 'Exams',
                children: <ExamsTab />,
            },
            {
                key: HomeTabKeys.Timesheet,
                label: 'Timesheet',
                children: <TimesheetTab />,
            },
        ],
        []
    )

    const onChangeTab = (tabId: string) => {
        navigate('/', {
            state: {
                type: tabId,
            },
        })
    }

    useEffect(() => {
        const tab = searchParams.get('tab') as HomeTabKeys
        if (tab && Object.values(HomeTabKeys).includes(tab)) {
            setSelectedTab(tab)
        } else {
            setSelectedTab(location.state?.type ?? HomeTabKeys.Tasks)
        }
    }, [location.state, searchParams])

    return (
        <div className={styles['home-page']} data-testid="home-wrapper">
            <HeaderComp />
            <Tabs
                tabBarStyle={{ margin: 'auto', fontSize: '16px', width: '85%', minWidth: '780px' }}
                activeKey={selectedTab}
                size="large"
                items={tabItems}
                onChange={onChangeTab}
            />
        </div>
    )
}
